import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page home"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "home-con"
};
const _hoisted_4 = {
  class: "person"
};
const _hoisted_5 = {
  class: "person-text"
};
const _hoisted_6 = {
  class: "person-name"
};
const _hoisted_7 = {
  class: "person-label"
};
const _hoisted_8 = {
  class: "person-label"
};
const _hoisted_9 = {
  class: "btns"
};
const _hoisted_10 = {
  class: "app"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "app-name"
};
const _hoisted_13 = ["src"];
import { computed, onActivated, ref } from "vue";
import { closeToast, showLoadingToast } from "vant";
import { useRouter } from "vue-router";
import { getMiniHome } from "@/api/mini";
import { gotoMiniPage } from "@/utils/miniPage";
import { clearToken, consumeAuthFresh, redirectToWxAuth, shouldRetryAuth, markReauthorization, rememberAuthReturnRoute } from "@/utils/wechat";
import { getInfo } from "@/api/login";
import homeBg from "@/assets/images/home_bg.png";
import defaultPhoto from "@/assets/images/default_photo.png";
import homeBtn1 from "@/assets/images/home_btn1.png";
import homeBtn2 from "@/assets/images/home_btn2.png";
import homeMore from "@/assets/images/home_more.png";
import homeSum1 from "@/assets/images/home_sum1.png";
import homeSum2 from "@/assets/images/home_sum2.png";
import homeSum3 from "@/assets/images/home_sum3.png";
import homeSum4 from "@/assets/images/home_sum4.png";
// 首页数据统计每行 2 个，最多展示 4 个卡片（对齐小程序首页）
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const personInfo = ref({});
    const menuList = ref([]);
    const dataList = ref([]);
    const refreshing = ref(false);
    // 首页数据统计卡片图标：按接口 icon 字段（1~4）对应本地图片
    const sumIcons = {
      "1": homeSum1,
      "2": homeSum2,
      "3": homeSum3,
      "4": homeSum4
    };
    const sumGroups = computed(() => {
      const items = dataList.value.slice(0, 4);
      const rows = [];
      for (let i = 0; i < items.length; i += 2) {
        rows.push(items.slice(i, i + 2).map((item, offset) => {
          var _item$icon;
          return {
            ...item,
            key: i + offset,
            icon: sumIcons[String((_item$icon = item.icon) !== null && _item$icon !== void 0 ? _item$icon : "")] || homeSum1
          };
        }));
      }
      return rows;
    });
    // 菜单图标缺失时的兜底色盘（按 menuId 取色）
    const iconPalette = ["#2776ff", "#39d2a3", "#ff9f43", "#8b5cf6", "#f06595", "#17a2b8", "#2f6fed"];
    const decorateMenu = (menus = []) => menus.map(item => {
      const num = Number(item.menuId);
      const index = Number.isFinite(num) && num >= 0 ? num % iconPalette.length : 0;
      return {
        ...item,
        fallbackBg: iconPalette[index],
        initial: String(item.menuName || "").charAt(0) || "•"
      };
    });
    // 小程序页面跳转（未迁移的页面会提示无权限）
    const goto = (url, query) => {
      gotoMiniPage(router, url, query);
    };
    // 校验是否已绑定手机号，未绑定则跳转绑定页
    const loadUser = async () => {
      // const res = await getMiniInfo();
      const res = await getInfo();
      const info = res === null || res === void 0 ? void 0 : res.data;
      if (!(info !== null && info !== void 0 && info.jobNum)) {
        // 去绑定页前清空本地缓存的账号数据（userInfo 带 401 跳转链接、user 是门禁等页面
        // 读取的当前人员信息），避免绑定新账号后仍读到上一个账号的残留数据
        localStorage.removeItem("userInfo");
        localStorage.removeItem("user");
        // 管理端解绑后，旧 token 对应的服务端会话可能残留解绑前的状态，
        // 直接用它提交 bind 会失败；非本轮新建的会话先重走一次授权换新会话。
        // 刚授权回来（consumeAuthFresh 命中）或授权失败退避期内则直接进绑定页，
        // 保证不会在「首页 <-> 授权页」之间无限往返
        if (consumeAuthFresh() || !shouldRetryAuth()) {
          await router.replace("/bind");
        } else {
          markReauthorization();
          rememberAuthReturnRoute();
          clearToken();
          redirectToWxAuth();
        }
        return;
      }
      localStorage.setItem("userInfo", JSON.stringify(info)); // 这里的userinfo携带了401跳转链接
      personInfo.value = info;
      await loadHome();
    };
    const loadHome = async () => {
      const res = await getMiniHome();
      const {
        personInfo: person,
        menuList: menus,
        dataList: stats
      } = (res === null || res === void 0 ? void 0 : res.data) || {};
      if (person) {
        personInfo.value = person;
        localStorage.setItem("user", JSON.stringify(person));
      }
      ;
      // 首页最多展示 11 个菜单，每行 4 个
      const limited = (menus || []).slice(0, 11);
      const size = 4;
      const groups = [];
      for (let i = 0; i < limited.length; i += size) {
        groups.push(decorateMenu(limited.slice(i, i + size)));
      }
      console.log(groups);
      menuList.value = groups;
      dataList.value = stats || [];
    };
    const onRefresh = async () => {
      try {
        await loadUser();
      } finally {
        refreshing.value = false;
      }
    };
    // 首页配置了 keep-alive，绑定成功跳回时组件是缓存实例，mounted 不会再执行；
    // 用 onActivated 替代：首次进入和每次返回首页都会重新拉取用户信息与首页数据
    onActivated(async () => {
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      try {
        await loadUser();
      } catch {
        // 请求失败时静默处理，停留在当前页
      } finally {
        closeToast();
      }
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => refreshing.value = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "home-nav"
        }, [_createElementVNode("span", {
          class: "home-title"
        }, "弘人智汇")], -1)), _createElementVNode("img", {
          class: "nav-img",
          src: _unref(homeBg),
          alt: ""
        }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [personInfo.value.photoPath ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          round: "",
          fit: "cover",
          width: 69,
          height: 69,
          src: personInfo.value.photoPath
        }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_van_image, {
          key: 1,
          round: "",
          fit: "cover",
          width: 69,
          height: 69,
          src: _unref(defaultPhoto)
        }, null, 8, ["src"])), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(personInfo.value.name), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(personInfo.value.deptName), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(personInfo.value.companyName), 1)])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
          class: "btn1",
          round: "",
          icon: _unref(homeBtn1),
          onClick: _cache[0] || (_cache[0] = $event => goto('/pages/index/index'))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("考勤打卡")])),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_van_button, {
          class: "btn2",
          round: "",
          icon: _unref(homeBtn2),
          onClick: _cache[1] || (_cache[1] = $event => goto('/pages/time/approval/list'))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("待处理")])),
          _: 1
        }, 8, ["icon"])]), _createElementVNode("div", _hoisted_10, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "app-title"
        }, "我的应用", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (row, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "app-con"
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.menuId,
              class: "item",
              onClick: $event => goto(item.component, item.query)
            }, [_createVNode(_component_van_image, {
              fit: "cover",
              width: 48,
              height: 48,
              src: item.lnkIcon || _unref(homeMore)
            }, null, 8, ["src"]), _createElementVNode("div", _hoisted_12, _toDisplayString(item.menuName), 1)], 8, _hoisted_11);
          }), 128)), index === menuList.value.length - 1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "item",
            onClick: _cache[2] || (_cache[2] = $event => _unref(router).push('/work'))
          }, [_createElementVNode("img", {
            src: _unref(homeMore),
            alt: ""
          }, null, 8, _hoisted_13), _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "app-name"
          }, "更多", -1))])) : _createCommentVNode("", true)]);
        }), 128))])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});